import { useUI } from "providers/UIProvider"
import useLaundry from "hooks/useLaundry"
import { useState } from "react"

import Modal from "components/UI/organisms/Modal"
import { Text, Box, Flex } from "@chakra-ui/react"
import UploadInput from "components/UI/molecules/UploadInput"
import Input from "components/UI/atoms/Input"


import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"

const AddLanguageModal = () => {
  const { modals, toggleModal, T } = useUI()

  const {
    form: {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      setValues,
      handleLogoChange,
      handle24Click,
      handleMapChange,
      handleSubmit,
      handleDenyClick
    },
    removeLogo,
    coordinates,
    setCoordinates,
    serviceData,
    updateServiceData,
    additionalServices,
    selectedAdditionalServices,
    handleAdditionalServiceClick,
    districtOptions
  } = useLaundry()

  const [value, setValue] = useState("")

  const renderLogoHelper = () => (
    <Box>
      <Flex flexDirection="row" gap={1}>
        <Text>
          {T("laundry.form.logo.helper.format")}:{" "}
        </Text>
        <Text color="primary" display="inline" fontWeight="bold">
          {"PNG"}
        </Text>
      </Flex>
      <Flex flexDirection="row" gap={1}>
        <Text>
          {T("laundry.form.logo.helper.size")}:{" "}
        </Text>
        <Text color="primary" display="inline" fontWeight="bold">
          {"500px - 500px"}
        </Text>
      </Flex>
    </Box>
  )

  const forceTouched = () => {
    touched.logo = true
  }


  return (
    <Modal
      isOpen={modals.addLanguageModal.isOpened}
      onClose={() => toggleModal("addLanguageModal", false)}
      title={T("languages.add_language.title")}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "640px",
        bodyPadding: "25px 25px 48px 25px",
      }}
    >
      <Flex style={{ flexDirection: "column", gap: 70 }}>
        <Flex style={{ flexDirection: "row", height: "40%", justifyContent: "space-evenly", alignItems: "flex-start" }}>
          <Flex style={{ display: "flex", flexDirection: "column" }}>
            <Input value={values.name}
              type="text"
              id="flag-name"
              name="language"
              onChange={handleChange}
              label={T("languages.enter_language")}
              width="198px"
              height="50px"
            />
          </Flex>
          <Flex style={{ display: "flex", flexDirection: "column" }}>
            <UploadInput
              onClick={forceTouched}
              name="logo"
              label={T("languages.language_flag")}
              accept="image/png"
              value={values.logo}
              error={(errors.logo && touched.logo) && errors.logo || ""}
              onChange={handleLogoChange}
              inputLabel={T("general.upload")}
              // file={logo}
              fileType="IMAGE"
              onRemove={removeLogo}
              inputStyles={{ height: "50px", width: "198px" }}
              helper={renderLogoHelper()}
              imageUrl={values.logo}
            />
          </Flex>
        </Flex>
        <Flex style={{ justifyContent: "center" }} padding="0 10px">
          <Button
            text={T("actions.add")}
            onClick={() => console.log("not implemented yet")}
            variant="success"
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
            styles={{ width: "220px", height: "63px", fontSize: "l" }}
          />
        </Flex>
      </Flex>
    </Modal>
  )
}

export default AddLanguageModal